
/* Brentos low-stock indicator */

(function () {

  function initLowStock(indicator) {

    if (indicator.dataset.initialised === 'true') return;

    const dataElement = indicator.querySelector(
      '[data-stock-variants]'
    );

    if (!dataElement) return;

    const productForm = indicator.closest('product-form');

    if (!productForm) return;

    const variants = JSON.parse(dataElement.textContent);
    const threshold = Number(indicator.dataset.threshold);
    const barMax = Number(indicator.dataset.barMax);

    const message = indicator.querySelector(
      '[data-stock-message]'
    );

    const fill = indicator.querySelector(
      '[data-stock-fill]'
    );

    function update() {

      const selectedInput = productForm.querySelector(
        'input[name="id"]:not([disabled]), select[name="id"]'
      );

      const variant = selectedInput
        ? variants[selectedInput.value]
        : null;

      if (
        !variant ||
        !variant.tracked ||
        variant.policy === 'continue' ||
        !variant.available ||
        variant.quantity <= 0 ||
        variant.quantity > threshold
      ) {
        indicator.hidden = true;
        return;
      }

      const quantity = variant.quantity;

      indicator.hidden = false;

      indicator.classList.toggle(
        'is-low',
        quantity <= 30
      );

      indicator.classList.toggle(
        'is-critical',
        quantity <= 10
      );

      message.textContent = quantity <= 10
        ? `Almost gone! Only ${quantity} left`
        : `Only ${quantity} left in stock`;

      const percentage = Math.min(
        100,
        Math.max(0, (quantity / barMax) * 100)
      );

      fill.style.width = `${percentage}%`;

    }

    const productPage = productForm.closest(
      '[data-js-product-component]'
    );

    const variantPicker = productPage?.querySelector(
      'product-variants'
    );

    if (variantPicker) {
      variantPicker.addEventListener(
        'VARIANT_CHANGE',
        update
      );
    }

    update();

    indicator.dataset.initialised = 'true';

  }

  function initAll(root = document) {

    if (root.matches?.('[data-brentos-low-stock]')) {
      initLowStock(root);
    }

    root.querySelectorAll(
      '[data-brentos-low-stock]'
    ).forEach(initLowStock);

  }

  function start() {

    initAll();

    // Initialise trackers inserted by dynamically loaded
    // Quick View popups, including bundle builder Quick Views.

    const observer = new MutationObserver(mutations => {

      for (const mutation of mutations) {

        for (const node of mutation.addedNodes) {

          if (node.nodeType !== 1) continue;

          initAll(node);

        }

      }

    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

  }

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      start
    );

  } else {

    start();

  }

  document.addEventListener(
    'shopify:section:load',
    () => initAll()
  );

})();
